export default "__VITE_ASSET__DUyiRGd5__"